<template>
    <div class="list-timeline">
        <EmptyMessage
            v-if="items.length === 0 && !isLoading"
            text="Здесь пока ничего нет."
            class="my-timeline__empty-message"
        />
        <LoadingMessage v-if="isLoading" text="Загрузка моего трека..." />
        <div
            class="list-timeline__item"
            :class="`list-timeline__item--${item.type}`"
            v-for="item in sortedItems"
            :key="item.id"
            @click="clickOnItem(item)"
        >
            <div class="list-timeline__item-icon" :class="`list-timeline__item-icon--${item.type}`">
                <component :is="TYPES[item.type].icon" />
            </div>
            <div class="list-timeline__item-content">
                <div class="list-timeline__item-name">{{ item.name }}</div>
                <div class="list-timeline__item-date">
                    <span class="list-timeline__item-date-start">{{ getDate(item.dateStart) }}</span>
                    –
                    <span class="list-timeline__item-date-end">{{ getDate(item.dateEnd) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import IconProject from '@/views/track/icons/IconProject.vue';
import IconCourse from '@/views/track/icons/IconCourse.vue';
import IconInternship from '@/views/track/icons/IconInternship.vue';
import EmptyMessage from '@/views/track/components/tabs/components/parts/EmptyMessage.vue';
import LoadingMessage from '@/views/track/components/tabs/components/parts/LoadingMessage.vue';

export default {
    name: 'ListTimeline',
    components: {
        IconProject,
        IconCourse,
        IconInternship,
        EmptyMessage,
        LoadingMessage,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            TYPES: {
                project: {
                    icon: 'IconProject',
                },
                event: {
                    icon: 'IconCourse',
                },
                internship: {
                    icon: 'IconInternship',
                },
            },
        };
    },
    computed: {
        sortedItems() {
            return [...this.items].sort((a, b) => {
                const startA = moment(a.dateStart);
                const startB = moment(b.dateStart);

                // Сначала сравниваем по dateStart
                if (!startA.isSame(startB)) {
                    return startA.isAfter(startB) ? -1 : 1;
                }

                // Если dateStart одинаковые, сравниваем по dateEnd
                const endA = moment(a.dateEnd);
                const endB = moment(b.dateEnd);
                return endA.isAfter(endB) ? -1 : 1;
            });
        },
    },
    methods: {
        getDate(date) {
            return moment(date).format('DD.MM.YYYY');
        },
        async clickOnItem(item) {
            switch (item.type) {
                case 'project':
                    window.open(`https://project.${window.rsvDomain}/${item.id}/`, '_blank');
                    break;
                case 'event':
                    window.open(item.eventSiteUrl, '_blank');
                    break;
                case 'internship':
                    window.open(`https://project.${window.rsvDomain}/${item.id}`, '_blank');
                    break;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.list-timeline {
    display: flex;
    flex-direction: column;
    gap: urem(16);

    &__item {
        display: flex;
        align-items: center;
        gap: urem(16);
        padding: urem(8) urem(16);
        border-radius: urem(10);

        &--project {
            background-color: #bdebf5;
            color: #251f45;
        }
        &--event {
            background-color: #cca0d4;
            color: #251f45;
        }
        &--internship {
            background-color: #eec980;
            color: #251f45;
        }
    }

    &__item-content {
        display: flex;
        flex-direction: column;
        gap: urem(4);
    }

    &__item-name {
        font-size: urem(14);
        font-weight: 500;
        line-height: urem(20);
        color: inherit;
    }

    &__item-icon {
        width: urem(32);
        height: urem(32);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        &--project {
            background-color: #edfcff;
        }
        &--event {
            background-color: #f5e3f8;
        }
        &--internship {
            background-color: #fbeed3;
        }

        svg {
            width: urem(20);
            height: urem(20);
        }
    }

    &__item-date {
        font-size: urem(14);
        font-weight: 400;
        line-height: urem(20);
        color: #251f45;
    }
}
</style>
